import { numericFormatter } from 'react-number-format';

export const convertToPercentageNumber = (
  value: number,
  clampPercentage = true
): number => {
  const percentage = value * 100;

  return clampPercentage ? Math.max(0, Math.min(100, percentage)) : percentage;
};

export const formatDecimalSeparator = ({
  value,
  decimalScale = 0,
  suffix,
}: {
  value?: number;
  decimalScale?: number;
  suffix?: string;
}): string => {
  return numericFormatter((value ?? 0).toString(), {
    decimalSeparator: ',',
    thousandSeparator: '.',
    decimalScale,
    suffix,
  });
};

export const convertToPercentageParsedString = (
  value: number,
  options?: { decimalScale?: number; clampPercentage?: boolean }
): string => {
  const percentage = convertToPercentageNumber(value, options?.clampPercentage);
  const format = numericFormatter(percentage.toString(), {
    decimalSeparator: '.',
    decimalScale: options?.decimalScale ?? 2,
    allowLeadingZeros: false,
  });
  return `${format}%`;
};
